import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SharedModule } from 'src/app/shared/shared.module';
import { VisualizzaModule } from '../visualizza/visualizza.module';
import { ClassificheInScadenzaComponent } from './classifiche-in-scadenza.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    SelectButtonModule,
    VisualizzaModule,
    AutoCompleteModule
  ],
  declarations: [
    ClassificheInScadenzaComponent
  ]
})
export class ClassificheInScadenzaModule { }
